//
//
//
//
//
//
//
//
//
//

export default {
  name: 'app',
  data () {
    return {
      heights:''
    }
  },
  methods:{
    hhs(){
      this.heights = window.screen.height - 153+'px'
    },
  }
}



// WEBPACK FOOTER //
// ./src/App.vue